import React, { useEffect } from "react";
import { AiOutlineMenu } from "react-icons/ai";
// import { FiShoppingCart } from "react-icons/fi";
// import { BsChatLeft } from "react-icons/bs";
// import { RiNotification3Line } from "react-icons/ri";
// import { MdKeyboardArrowDown } from "react-icons/md";
// import { TfiNewWindow } from "react-icons/tfi";
// import { ImNewTab } from "react-icons/im";
// import { RxOpenInNewWindow } from "react-icons/rx";
// import { MdOpenInNew } from "react-icons/md";
import { MdPointOfSale } from "react-icons/md";
import { TbShoppingCartPlus } from "react-icons/tb";
// import { FcMoneyTransfer } from "react-icons/fc";
import { TbCashRegister } from "react-icons/tb";
// import { LuFileBox } from "react-icons/lu";
import { BsCashCoin } from "react-icons/bs";
//import { PiCashRegisterLight } from "react-icons/pi";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { IoMdLogOut } from "react-icons/io";
// import { Cart, Chat, Notification, UserProfile } from '.';
import { useStateContext } from "../contexts/ContextProvider";
import { Col, Row } from "react-bootstrap";
import { showInfoToast } from "./ToastMesg";

const NavButton = ({ title, customFunc, icon, color, dotColor }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ color }}
      className="relative text-xl rounded-full p-2 m-1 hover:bg-light-gray"
    >
      <span
        style={{ background: dotColor }}
        className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
      />
      {icon}
    </button>
  </TooltipComponent>
);

const Navbar = () => {
  const {
    currentColor,
    activeMenu,
    setActiveMenu,
    userPermID,
    userName,
    userProfile,
    setScreenSize,
    screenSize,
    handleLogoutClick,
    storeG,
    companyG,
    setStoreGlobal,
    setCompanyGlobal,
    storesG,
    companysG,
  } = useStateContext();

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  });

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setScreenSize]);

  useEffect(() => {
    setActiveMenu(screenSize > 1100);
  }, [screenSize, setActiveMenu]);

  const handleActiveMenu = () => setActiveMenu(!activeMenu);

  const handleNewSale = () => window.open(`/Sales/AddSalesOrder`, "_blank");

  const handleNewPurchase = () => {
    if (companyG.company_id) window.open(`/Purchase/AddPurchaseOrder`);
    else showInfoToast("Info!", "Please select Company to proceed!");
  };

  const handleNewReceipt = () => window.open(`/Receipt/AddReceipt`, "_blank");

  const handleNewPayment = () => window.open(`/Payment/AddPayment`, "_blank");

  // const handleStockReport = () =>
  //   window.open(`/Overview/SummaryReport`, "_blank");

  const handleSetStore = (e) => {
    const s_id = storesG.find((item) => item.name === e.target.value);
    setStoreGlobal(s_id.store_id, s_id.name, s_id.tax);
  };

  const handleSetCompany = (e) => {
    const c_id = companysG.find((item) => item.name === e.target.value);
    setCompanyGlobal(c_id.company_id, c_id.name);
  };

  return (
    <div
      fluid="true"
      className="g-0 p-1 w-full md:ml-6 md:mr-6"
      style={{ maxWidth: "calc(100% - 72px)" }}
    >
      <Row>
        <Col sm={1}>
          <NavButton
            title="Menu"
            customFunc={handleActiveMenu}
            color={currentColor}
            icon={<AiOutlineMenu />}
            style={{ alignSelf: "left" }}
          />
        </Col>
        <Col sm={true} className="flex justify-end">
          {userPermID.includes(29) && (
            <NavButton
              title="New Sale"
              customFunc={handleNewSale}
              color={currentColor}
              icon={<MdPointOfSale className="font-bold text-2xl" />}
            />
          )}
          {userPermID.includes(26) && (
            <NavButton
              title="New Purchase"
              customFunc={handleNewPurchase}
              color={currentColor}
              icon={<TbShoppingCartPlus className="font-bold text-2xl" />}
            />
          )}
          {userPermID.includes(38) && (
            <NavButton
              title="New Receipt"
              customFunc={handleNewReceipt}
              color={currentColor}
              icon={<TbCashRegister className="font-bold text-2xl" />}
            />
          )}
          {userPermID.includes(38) && (
            <NavButton
              title="New Payment"
              customFunc={handleNewPayment}
              color={currentColor}
              icon={<BsCashCoin className="font-bold text-2xl" />}
            />
          )}
          {/* {userPermID.includes(47) && (
            <NavButton
              title="Summary Report"
              customFunc={handleStockReport}
              color={currentColor}
              icon={<LuFileBox className="font-bold text-2xl" />}
            />
          )} */}
          <div className="ml-4 mr-4">
            <select
              className="select-custom rounded-xl"
              value={storeG.name}
              onChange={handleSetStore}
              disabled
              //={!userPermID.includes(10)}
              style={{
                fontSize: "15px",
                padding: "7px",
                //!userPermID.includes(10) &&
                background: "lightgrey",
              }}
            >
              {storesG?.map((item) => (
                <option key={item.store_id}>{item.name}</option>
              ))}
            </select>
            <select
              className="select-custom rounded-xl"
              value={companyG.name}
              onChange={handleSetCompany}
              disabled={!userPermID.includes(10)}
              style={{
                fontSize: "15px",
                padding: "7px",
                background: !userPermID.includes(10) && "lightgrey",
              }}
            >
              {companysG?.map((item) => (
                <option key={item.company_id}>{item.name}</option>
              ))}
            </select>
          </div>
          <TooltipComponent content="Profile" position="BottomCenter">
            <div
              // className="flex items-center gap-2 cursor-pointer p-1 hover:bg-light-gray rounded-lg"
              className="flex items-center gap-2 p-1 h-100 hover:bg-light-gray rounded-lg text-gray-400 font-bold text-14"
              //onClick={() => handleClick("userProfile")}
            >
              {userProfile && (
                <img
                  className="rounded-full w-10 h-10"
                  src={`data:image/jpeg;base64,${userProfile}`}
                  alt="user-profile"
                />
              )}
              {userName}
              {/* <p>
                {/* <span className="text-gray-400 text-14">Hi,</span>
                <span className="text-gray-400 font-bold ml-1 text-14">
                  Michael
                </span>
              </p> */}
              {/* <MdKeyboardArrowDown className="text-gray-400 text-14" /> */}
            </div>
          </TooltipComponent>
          <NavButton
            title="Sign Out"
            customFunc={handleLogoutClick}
            color={currentColor}
            icon={<IoMdLogOut className="font-bold text-2xl" />}
          />
          {/* 
        {isClicked.cart && (<Cart />)}
        {isClicked.chat && (<Chat />)}
        {isClicked.notification && (<Notification />)}
        {isClicked.userProfile && (<UserProfile />)} */}
        </Col>
      </Row>
    </div>
  );
};

export default Navbar;
